"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function formatMillisAsAmazonDate(milliseconds) {
    if (isNaN(milliseconds)) {
        return null;
    }
    const sanitizedDate = new Date(milliseconds);
    return (sanitizedDate
        .toISOString()
        .split('.')[0]
        .replace(/[\-:.]/g, '') + 'Z');
}
exports.default = formatMillisAsAmazonDate;
